import { lazy } from 'react';

export const AdministrationAsync = lazy(() => import('./administration.component'));
